/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BedroomsInputs */

const en_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrooms`)
};

const es_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dormitorios`)
};

const fr_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chambres`)
};

const de_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlafzimmer`)
};

const ja_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベッドルーム数`)
};

const zh_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卧室`)
};

const ar_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غرف النوم`)
};

const id_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamar Tidur`)
};

const it_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camere da Letto`)
};

const ru_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спальни`)
};

const pt_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartos`)
};

const ko_bedrooms = /** @type {(inputs: BedroomsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`침실 수`)
};

/**
* | output |
* | --- |
* | "Bedrooms" |
*
* @param {BedroomsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const bedrooms = /** @type {((inputs?: BedroomsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BedroomsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bedrooms(inputs)
	if (locale === "es") return es_bedrooms(inputs)
	if (locale === "fr") return fr_bedrooms(inputs)
	if (locale === "de") return de_bedrooms(inputs)
	if (locale === "ja") return ja_bedrooms(inputs)
	if (locale === "zh") return zh_bedrooms(inputs)
	if (locale === "ar") return ar_bedrooms(inputs)
	if (locale === "id") return id_bedrooms(inputs)
	if (locale === "it") return it_bedrooms(inputs)
	if (locale === "ru") return ru_bedrooms(inputs)
	if (locale === "pt") return pt_bedrooms(inputs)
	return ko_bedrooms(inputs)
});